import api from './api-adapter';

export async function load () {
  const { results } = await api.get('/provider/');
  return results.map(({ name, description }) => ({ id: name, name: description }));
}
